// src/pages/offlineSales/salesRepOptions.js
export const toSalesRepOptions = (reps = []) => reps.map(rep => ({
  value: rep.id,
  label: rep.UserRole?.name ? `${rep.name} — ${rep.UserRole.name}` : rep.name,
}));
